import React from "react";
import { Button } from "./ui/button";
import { Check } from "lucide-react";

export default function BookingSuccess({ booking, onClose }) {
  return (
    <div className="py-6 space-y-4" data-testid="booking-success">
      <div className="flex items-center gap-3 p-4 rounded-sm bg-[#FF2079]/10 border border-[#FF2079]/30">
        <Check className="w-5 h-5 text-[#FF2079]" />
        <div className="text-sm">
          Reservation <span className="font-mono text-[#FFB6C1]">{booking.id.slice(0, 8)}</span> created.
        </div>
      </div>
      <div className="space-y-2 text-sm text-[#A09CA3]">
        <div><span className="text-white">Service:</span> {booking.service_name}</div>
        <div><span className="text-white">When:</span> {booking.date} · {booking.time}</div>
        <div><span className="text-white">Guest:</span> {booking.name}</div>
      </div>
      <Button
        data-testid="booking-close-btn"
        onClick={onClose}
        className="w-full bg-[#FF2079] hover:bg-[#D91666] text-white rounded-sm h-11 text-[11px] tracking-[0.28em] uppercase"
      >
        Close
      </Button>
    </div>
  );
}
